import { createAction, createReducer } from '@reduxjs/toolkit';
import { multiTariffInitTab } from 'reactApp/appHelpers/featuresHelpers/features/multiTariff';
import { multiTariffMobileInitTab } from 'reactApp/appHelpers/featuresHelpers/features/multiTariffMobile';
import type { ActivatePromocode, State } from 'reactApp/modules/quotaLanding/quotaLanding.types';
import type { ETabsName } from 'reactApp/ui/TariffSectionNew/TariffSection.constants';

const initialState: State = {
    isLoading: true,
    isLoaded: false,
    hasError: false,
    multiTariffActiveTab: multiTariffInitTab,
    multiTariffActiveTabMobile: multiTariffMobileInitTab,
};

export const loadQuotaLandingRequest = createAction('quotaLanding/loadQuotaLandingRequest');
export const loadQuotaLandingProducts = createAction('quotaLanding/loadQuotaLandingProducts');
export const loadQuotaTariffsLandingRequest = createAction('quotaLanding/loadQuotaTariffsLandingRequest');
export const loadQuotaLandingSuccess = createAction('quotaLanding/loadUserQuotaSuccess');
export const loadQuotaLandingFailure = createAction('quotaLanding/loadQuotaLandingFailure');
export const showLandingTariffsAction = createAction('quotaLanding/showLandingTariffs');
export const sendShowLandingAnalyticsAction = createAction('quotaLanding/sendShowLandingtAnalytics');
export const changeMultiTariffActiveTabAction = createAction<ETabsName>('qoutaLanding/changeMultiTariffActiveTab');
export const changeMultiTariffMobileActiveTabAction = createAction<ETabsName>('quotaLanding/changeMultiTariffMobileActiveTab');
export const activatePromocodeRequest = createAction<ActivatePromocode>('quotaLanding/activatePromocode');

export const quotaLandingReducer = createReducer(initialState, {
    [loadQuotaLandingRequest.type]: (state) => {
        state.isLoading = true;
        state.isLoaded = false;
    },
    [loadQuotaLandingSuccess.type]: (state) => {
        state.isLoading = false;
        state.isLoaded = true;
        state.hasError = false;
    },
    [loadQuotaLandingFailure.type]: (state) => {
        state.isLoading = false;
        state.isLoaded = false;
        state.hasError = true;
    },
    [changeMultiTariffActiveTabAction.type]: (state, { payload }) => {
        state.multiTariffActiveTab = payload;
    },
    [changeMultiTariffMobileActiveTabAction.type]: (state, { payload }) => {
        state.multiTariffActiveTabMobile = payload;
    },
});
